import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { get } from 'lodash';

import { getTimeFormat } from '../../../service/NavPointsUtils';
import { SummaryLegInfo } from '../SummaryLegInfo/SummaryLegInfo';
import { ErrorBoundary } from '../../ErrorBoundary/ErrorBoundary';
import { useStyles } from './useStyles';
import { Typography } from '../../material-ui/Typography';
import { getSendedDataPreview, getSendedDataPreviewTotal } from '../../../selectors/sended-data';

export const SummaryTaskPanel = memo(() => {
    const legs = useSelector(getSendedDataPreview);
    const total = useSelector(getSendedDataPreviewTotal);
    const declaration = useSelector((state) => get(state, 'routesDeclaration.summary.legs', {}));
    const classes = useStyles();
    const {
        night = false,
        biologicalNight = false,
        parking = false,
        delay = false,
        rest = false,
        dist = false,
        landings = false,
    } = declaration || {};
    const flightInfo = `${getTimeFormat(total.flightTime)}${
        total.flightTime !== total.timeOnDevices && total.timeOnDevices ? `(${getTimeFormat(total.timeOnDevices)})` : ''
    }`;
    const landingsInfo = `${total.landings}${
        total.landings !== total.landingsOnDevices && total.landingsOnDevices ? `(${total.landingsOnDevices})` : ''
    }`;
    const { t: translate } = useTranslation();

    return (
        <ErrorBoundary>
            {legs ? (
                <table className={classes.table}>
                    <thead>
                        <tr className={classes.header}>
                            <th className={classes.headerCell}>{translate('summaryTaskPage.flight')}</th>
                            <th className={classes.headerCell}>{translate('tables.route')}</th>
                            <th className={classes.headerCell}>{translate('tables.duty')}</th>
                            <th className={classes.headerCell}>{translate('tables.engine')}</th>
                            <th className={classes.headerCell}>{translate('tables.blockTime')}</th>
                            <th className={classes.headerCell}>{translate('tables.to-la')}</th>
                            <th className={classes.headerCell}>{translate('tables.flight')}</th>
                            {night && <th className={classes.headerCell}>{translate('summaryTaskPage.night')}</th>}
                            {biologicalNight && <th className={classes.headerCell}>{translate('summaryTaskPage.bio')}</th>}
                            {parking && <th className={classes.headerCell}>{translate('summaryTaskPage.parking')}</th>}
                            {delay && <th className={classes.headerCell}>{translate('summaryTaskPage.delay')}</th>}
                            {rest && <th className={classes.headerCell}>{translate('summaryTaskPage.rest')}</th>}
                            {dist && <th className={classes.headerCell}>{translate('summaryTaskPage.distance')}</th>}
                            {landings && <th className={classes.headerCell}>{translate('summaryTaskPage.landings')}</th>}
                        </tr>
                    </thead>
                    {legs &&
                        legs.map((leg, index) => (
                            <SummaryLegInfo leg={leg} key={leg.id} number={index} declaration={declaration} lastLeg={legs.length - 1} />
                        ))}
                    <tfoot>
                        <tr className={classes.footRow}>
                            <td>{translate('summaryTaskPage.total')}:</td>
                            <td></td>
                            <td>{getTimeFormat(total.workTime)}</td>
                            <td></td>
                            <td>{getTimeFormat(total.blockTime)}</td>
                            <td></td>
                            <td>{flightInfo}</td>
                            {night && <td>{getTimeFormat(total.timeFlightNight)}</td>}
                            {biologicalNight && <td>{getTimeFormat(total.timeBiologicalNight)}</td>}
                            {parking && <td>{getTimeFormat(total.timeWorkParking)}</td>}
                            {delay && <td>{getTimeFormat(total.timeWorkDelay)}</td>}
                            {rest && <td>{getTimeFormat(total.timeWorkRest)}</td>}
                            {dist && <td>{total.distance}</td>}
                            {landings && <td>{landingsInfo}</td>}
                        </tr>
                    </tfoot>
                </table>
            ) : (
                <Typography className={classes.text}>{translate('messages.noInfoForLeg')}</Typography>
            )}
        </ErrorBoundary>
    );
});
